import axios from "axios";
import router from "../router";
import Vue from "vue";
import UserService from "../services/userService";

export default (server)  => {
    const axiosInstance = axios.create({
        baseURL: `${server.server_api}/api`,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    });

    Vue.prototype.$http = axiosInstance;
    Vue.config.productionTip = false;
    axiosInstance.defaults.timeout = 1000000;

    axiosInstance.interceptors.request.use(
        (config) => {
            let name = server.server_name;
            if (name.indexOf('https://') > -1)  name = name.replace('https://','');
            if (name.indexOf('http://') > -1)  name = name.replace('http://','');
            let cloudAccesstoken = JSON.parse(localStorage.getItem(name));
            if (cloudAccesstoken) {
                config.headers.common["Authorization"] = `Bearer ${cloudAccesstoken}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
    axiosInstance.interceptors.response.use(
        (response) => {
            if (response.status === 200 || response.status === 201) {
                return Promise.resolve(response);
            } else {
              return Promise.reject(response);
            }
        },
        async (error)  => {
            if (error && error.response && error.response.status) {
                switch (error.response.status) {
                    case 429: // Too many requests
                        break;
                    case 401:{
                        let secretkey = await UserService.getSecretKey(server.server_api)
                        .then((data) => {
                            if (data.data.data)
                                return data.data.data
                        }).catch((err) => {
                            console.log(err);
                        });
                        let cloudAccesstoken = await UserService.getCloudToken(server.server_api, secretkey)
                        .then((data2) => {
                            if (data2.data.data)
                                return data2.data.data.access_token
                        }).catch((err) => {
                            console.log(err)
                        });
                        let name = server.server_name;
                        if (name.indexOf('https://') > -1) 
                            name = name.replace('https://','');
                        if (name.indexOf('http://') > -1) 
                            name = name.replace('http://','');
                        localStorage.setItem(name, JSON.stringify(cloudAccesstoken));
                        break;
                    } 
                    case 403:
                        router.replace({
                            path: "/login",
                            query: { redirect: router.currentRoute.fullPath },
                        });
                        break;
                    case 404:
                        alert("page not exist");
                        break;
                    case 502:
                        setTimeout(() => {
                            router.replace({
                                path: "/login",
                            });
                        }, 1000);
                        break;
                    default:
                        "It does not have HTTP ok status"
                }
            }
            return Promise.reject(error);
        }
    );
    return axiosInstance;
};
